<template>
    <div id="edit">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-users"></i> Users</div>
        </div>
        <hr>
        <form class="box">
            <div class="columns is-multiline">              
                <div class="column is-6">
                    <div class="field">
                      <bulma-input name="email" v-model="user.email" rules="required|email" placeholder='Email'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="name" v-model="user.name" rules="required" placeholder='Name'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="nick" v-model="user.nick" rules="required" placeholder='Nick'/>
                    </div>
                </div>

                <div class="column is-6" v-if="roles && roles.length > 0">
                    <div class="field">
                        <label class="label">Roles:</label>
                        <div class="select is-fullwidth">
                            <select v-model="user.role">
                                <option v-bind:value="role.id" v-for="role in roles">{{role.name}}</option>                                          
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-multiline"> 
                <div class="column is-2">                    
                    <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>                    
                </div>              
                <div class="column is-2 is-offset-8 is-pulled-right">                                           
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>                   
                </div>              
            </div>                      
        </form>
    </div>  
</template>

<script>
import UserRepo from '../../repos/UserRepo'
import RoleRepo from '../../repos/RoleRepo'
import _ from 'lodash'

export default {
  name: 'users-edit',
  components: {},
  data() {
        return {
            repo: new UserRepo(this.$auth),
            roleRepo: new RoleRepo(this.$auth),            
            loading: false,
            oldRoles: null,            
            roles: [],            
            user: {role: '2'},
        }
  },
  created(){  
    this.getRoles();    
    this.getUser(this.$route.params.id);
  },
  methods: {
    getUser(id){
        this.repo.show(id).then(response => { 
            let user = response.data.data;            
            this.oldRoles = JSON.parse(JSON.stringify(user.roles));
            this.user = this.prepareUser(user);            
        });         
    },
    getRoles(){
        this.roleRepo.all().then(response => {            
            this.roles = response.data.data;
        });         
    },
    prepareUser(user){
        //user.projects = user.projects ? user.projects : [];
        let projects = [];
        let roles = [];        
        
        _.forEach(user.roles, function(value) {
          roles.push(value.id);  
        });
        
        user.role = roles[0];
        
        user.name = user.profile.name;

        user.nick = user.profile.nick;

        return user;
    },
    save(){            
        this.$validator.validateAll().then((result) => {
	    if (result) {
                let self = this;
                this.loading = true;                                
                
                this.repo.update(this.user.id, this.user).then(function (response) {                                                                            
                    
                    if(self.oldRoles && self.oldRoles.length > 0){
                        if(self.user.role != self.oldRoles[0].id) {
                            self.saveRole(self.user.id, self.oldRoles[0].id, self.user.role);
                        }
                    }
                    else{
                        self.attachRole(self.user.id, self.user.role);
                    }
                    
                    self.loading = false;
                    self.$toast.success(response.data.message);
                    self.$router.push('/dashboard');
                }).catch(function(response){
                    self.loading = false;                    
                    return Promise.reject(response);
                });
            }
        });
    
    },
    
    saveRole(id, old_role_id, new_role_id){
        this.repo.attachRole(id, new_role_id).then(response => {
            this.repo.detachRole(id, old_role_id);
        });
    },   
    attachRole(id, role_id){    
        this.repo.attachRole(id, role_id).then(response => {
        });
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/users/Edit.vue